import { ApiPath } from "enums";
import { Get } from "utils";

export const getUserStation = async () => {
  const res = await Get(`${ApiPath.GetUserStation}`);
  return res.data;
};
